import React, {
  ReactElement,
  useCallback,
  useRef,
  useState,
} from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {
  Autocomplete,
  Chip,
  DialogContentText, Stack,
  TextField,
  Typography,
} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import api from '../../../services/api';
import {serviceReservation} from '../../../schema/serviceReservation';
import ColorizeIcon from '@mui/icons-material/Colorize';
import {LoadingButton} from '@mui/lab';
import {serviceProviderEventStaff} from '../../../schema/serviceProviderEventStaff';
import {SlidingPaneAddNew} from '../../Page/SlidingPaneAddNew';
import {enumItems} from '../../../schema/enumItems';
import AddIcon from '@mui/icons-material/Add';
import {DailyTransferSchedule} from "../../ActivityReservations/DailyTransferSchedule";
import {DailyStaffSchedule} from "../../ActivityReservations/DailyStaffSchedule";

export const ButtonCell = ({
                             props,
                             refreshData,
                           }: {
  props: any;
  refreshData: () => void;
}): ReactElement => {

  const divRef = useRef(null);

  const [openSelectArtist, setOpenSelectArtist] = useState<any>(false);
  const [openSelectGuide, setOpenSelectGuide] = useState<any>(false);
  const [openSelectDriver, setOpenSelectDriver] = useState<any>(false);
  const [openSelectVehicle, setOpenSelectVehicle] = useState<any>(false);
  const [openSelectPackage, setOpenSelectPackage] = useState<any>(false);
  const [
    openAddNewEventStaffToServiceProviderService,
    setOpenAddNewEventStaffToServiceProviderService,
  ] = useState<any>(false);
  const [selected, setSelected] = useState<any>(undefined);
  const [loadingButton, setLoadingButton] = useState<any>(false);

  const handleCloseArtist = () => {
    setOpenSelectArtist(false);
  };
  const handleCloseGuide = () => {
    setOpenSelectGuide(false);
  };

  const handleCloseDriver = () => {
    setOpenSelectDriver(false);
  };
  const handleCloseVehicle = () => {
    setOpenSelectVehicle(false);
  };

  const handleClosePackage = () => {
    setOpenSelectPackage(false);
  };

  const handleSave = useCallback(async () => {
    setLoadingButton(true);
    await serviceReservation.client
      .update(props.row.id, {
        ['selected_staff']: selected,
        ['schemaColumns']: serviceReservation.columns,
      })
      .then((res) => {
        setLoadingButton(false);
        refreshData();
        handleCloseArtist();
        handleClosePackage();
        handleCloseGuide();
      })
      .finally(() => {
        setLoadingButton(false);
      });
  }, [selected]);
  const handleSaveDriver = useCallback(async () => {
    setLoadingButton(true);
    await serviceReservation.client
      .update(props.row.id, {
        ['driver']: selected,
        ['schemaColumns']: serviceReservation.columns,
      })
      .then((res) => {
        setLoadingButton(false);
        refreshData();
        handleCloseArtist();
        handleClosePackage();
        handleCloseGuide();
      })
      .finally(() => {
        setLoadingButton(false);
      });
  }, [selected]);

  const handleSaveVehicle = useCallback(async () => {
    setLoadingButton(true);
    await serviceReservation.client
      .update(props.row.id, {
        ['vehicle']: selected,
        ['schemaColumns']: serviceReservation.columns,
      })
      .then((res) => {
        setLoadingButton(false);
        refreshData();
        handleCloseArtist();
        handleClosePackage();
        handleCloseGuide();
        handleCloseDriver();
        handleCloseVehicle();
      })
      .finally(() => {
        setLoadingButton(false);
      });
  }, [selected]);

  const handleSavePackage = useCallback(async () => {
    setLoadingButton(true);
    await api
      .post(
        `/generate-service-reservations/${props.row?.id}/${props.row?.activity_reservation?.id}`,
        {
          selected_package: selected?.id,
        }
      )
      .then((res) => {
      })
      .finally(() => {
        setLoadingButton(false);
        refreshData();
        handleCloseArtist();
        handleClosePackage();
        handleCloseGuide();
      });
  }, [selected]);

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = React.useState<
    any
  >({
    schema: serviceProviderEventStaff,
    row: {},
  });

  const fetchSelectOptions = async () => {

    const searchParams = new URLSearchParams({});

    if (props.value === 'choose-staff') {
      searchParams.set(
        'service_provider_id',
        props.row?.service_provider_id
      );
      searchParams.set('service_id', props.row?.service_id);

      await api
        .get(`/admin/get-staff-by-service`, searchParams)
        .then((res: any) => {
          res.unshift({id: 0, name: '', isButton: true});
          setOptions(res);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    }
    if (props.value === 'choose-driver') {
      searchParams.set(
        'service_provider_id',
        props.row?.service_provider_id
      );
      searchParams.set('service_id', props.row?.service_id);

      await api
        .get(`/admin/get-driver-by-service`, searchParams)
        .then((res: any) => {
          res.unshift({id: 0, name: '', isButton: true});
          setOptions(res);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    }
    if (props.value === 'choose-vehicle') {
      searchParams.set(
        'service_provider_id',
        props.row?.service_provider_id
      );
      searchParams.set('service_id', props.row?.service_id);

      await api
        .get(`/admin/get-vehicle-by-service`, searchParams)
        .then((res: any) => {
          res.unshift({id: 0, name: '', isButton: true});
          setOptions(res);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    }
    if (props.value === 'choose-package') {
      await api
        .get(
          `/activity-reservations-selectable-service-packages/${props.row?.id}`,
          searchParams
        )
        .then((res: any) => {
          setOptions(res);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    }
  }

  const handleOnChange = (event: any, value: any) => {
    if (value?.isButton) {
      setCurrentAddNewPaneEntity({
        row: {
          id: 'new',
          service_provider: {
            id: props?.row.service_provider_id,
            name: props?.row.service_provider?.name,
          },
        },
        schema: serviceProviderEventStaff,
      });
    } else {
      setSelected(value);
    }
  };

  return (
    <div ref={divRef} className={``}>
      <Button
        size={'small'}
        variant="text"
        sx={{
          fontSize: '11px'
        }}
        onClick={(event) => {
          event.stopPropagation();
          if (props.value === 'choose-staff') {
            setOpenSelectGuide(props.row);
          }
          if (props.value === 'choose-package') {
            setOpenSelectPackage(props.row);
          }
          if (props.value === 'choose-driver') {
            setOpenSelectDriver(props.row);
          }
          if (props.value === 'choose-vehicle') {
            setOpenSelectVehicle(props.row);
          }
        }}
      >
        Select
      </Button>

      {openSelectArtist && (
        <>
          <Dialog open={true} onClose={handleCloseArtist}>
            <DialogTitle>
              {`Select Artist for ${props.row?.service} Service`}
            </DialogTitle>
            <DialogContent>
              <Autocomplete
                freeSolo
                sx={{
                  py: '10px',
                }}
                openOnFocus
                onOpen={() => fetchSelectOptions()}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.id === value.id
                }
                onChange={(event, value, reason, details) => {
                  setSelected(value);
                }}
                getOptionLabel={(option: any) => option?.name}
                getOptionKey={(option: any) => option?.id}
                options={options}
                loading={loading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Artist"
                    autoFocus
                    focused
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20}/>
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </DialogContent>
            <DialogActions>
              <LoadingButton
                loading={loadingButton}
                onClick={() => {
                  setOpenSelectArtist(false);
                }}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                loading={loadingButton}
                onClick={handleSave}
                autoFocus
                variant={'contained'}
              >
                Save
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </>
      )}

      {openSelectDriver && (
        <>
          <Dialog open={true} onClose={handleCloseDriver}>
            <DialogTitle>
              {`Select Driver for ${props.row?.service?.name} Service`}
            </DialogTitle>
            <DialogContent>
              <Autocomplete
                freeSolo
                sx={{
                  py: '10px',
                }}
                openOnFocus
                onOpen={() => fetchSelectOptions()}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.id === value.id
                }
                onChange={(event, value, reason, details) => {
                  handleOnChange(event, value);
                }}
                getOptionLabel={(option: any) => option?.name}
                getOptionKey={(option: any) => option?.id}
                renderOption={(props: any, option: any) => {
                  return (
                    <Box
                      component="li"
                      sx={{'& > img': {mr: 2, flexShrink: 0}}}
                      {...props}
                    >
                      {option?.isButton ? (
                        <Button
                          variant="contained"
                          startIcon={<AddIcon/>}
                          size={'small'}
                          fullWidth
                        >
                          Add new
                        </Button>
                      ) : (
                        <>
                          {(option?.color && typeof option?.color === 'string' && !option?.isButton) ? (
                            <Chip
                              style={{
                                background: `#${option?.color}`,
                                color: '#fff',
                              }}
                              icon={
                                <ColorizeIcon color={'disabled'} sx={{color: 'white'}}/>
                              }
                              label={`#${option.name}`}
                            />
                          ) : (
                            <>{option?.name ? option.name : '-'}</>
                          )}
                        </>
                      )}
                    </Box>
                  );
                }}
                options={options}
                loading={loading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label=""
                    autoFocus
                    focused
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20}/>
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </DialogContent>
            <DialogActions>
              <LoadingButton
                loading={loadingButton}
                onClick={() => {
                  setOpenSelectDriver(false);
                }}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                loading={loadingButton}
                onClick={handleSaveDriver}
                autoFocus
                variant={'contained'}
              >
                Save
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </>
      )}
      {openSelectVehicle && (
        <>
          <Dialog open={true} onClose={handleCloseVehicle}>
            <DialogTitle>
              {`Select Vehicle for ${props.row?.service?.name} Service`}
            </DialogTitle>
            <DialogContent>
              <Autocomplete
                freeSolo
                sx={{
                  py: '10px',
                }}
                openOnFocus
                onOpen={() => fetchSelectOptions()}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.id === value.id
                }
                onChange={(event, value, reason, details) => {
                  handleOnChange(event, value);
                }}
                getOptionLabel={(option: any) => option?.name}
                getOptionKey={(option: any) => option?.id}
                renderOption={(props: any, option: any) => {
                  return (
                    <Box
                      component="li"
                      sx={{'& > img': {mr: 2, flexShrink: 0}}}
                      {...props}
                    >
                      {option?.isButton ? (
                        <Button
                          variant="contained"
                          startIcon={<AddIcon/>}
                          size={'small'}
                          fullWidth
                        >
                          Add new
                        </Button>
                      ) : (
                        <>
                          {(option?.color && typeof option?.color === 'string' && !option?.isButton) ? (
                            <Chip
                              style={{
                                background: `#${option?.color}`,
                                color: '#fff',
                              }}
                              icon={
                                <ColorizeIcon color={'disabled'} sx={{color: 'white'}}/>
                              }
                              label={`#${option.name}`}
                            />
                          ) : (
                            <>{option?.name ? option.name : '-'}</>
                          )}
                        </>
                      )}
                    </Box>
                  );
                }}
                options={options}
                loading={loading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label=""
                    autoFocus
                    focused
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20}/>
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </DialogContent>
            <DialogActions>
              <LoadingButton
                loading={loadingButton}
                onClick={() => {
                  setOpenSelectDriver(false);
                }}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                loading={loadingButton}
                onClick={handleSaveVehicle}
                autoFocus
                variant={'contained'}
              >
                Save
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </>
      )}

      {openSelectGuide && (
        <>
          <Dialog
            open={true}
            onClose={handleCloseGuide}
            sx={{
              maxWidth: '700px'
            }}
          >
            <DialogTitle>{`Select Staff for Service`}</DialogTitle>
            <DialogContent>

              <Stack direction={'row'} gap={1}>
                <Stack
                  sx={{
                    overflowY: 'auto',
                    maxHeight: {
                      md: 'calc(100vh - 200px)',
                    },
                    width: '300px',
                  }}
                >
                  <Autocomplete
                    freeSolo
                    sx={{
                      py: '10px',
                    }}
                    onOpen={() => fetchSelectOptions()}
                    openOnFocus={true}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option: any) => option?.name}
                    getOptionKey={(option: any) => option?.id}
                    onChange={(event, value, reason, details) => {
                      handleOnChange(event, value);
                    }}
                    options={options}
                    loading={loading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        autoFocus
                        focused
                        label="Staff"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loading ? (
                                <CircularProgress color="inherit" size={20}/>
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props: any, option: any) => {
                      return (
                        <Box component="li" {...props}>
                          {option?.isButton && (
                            <Button
                              startIcon={<AddIcon/>}
                              size={'small'}
                              variant="contained"
                              fullWidth
                            >
                              Add new
                            </Button>
                          )}
                          <>{option?.name ? option.name : '-'}</>
                        </Box>
                      );
                    }}
                  />
                </Stack>

                <Stack sx={{
                  width: '400px'
                }}>
                  <DailyStaffSchedule
                    date={'2025-09-05'}
                  />
                </Stack>
              </Stack>


            </DialogContent>
            <DialogActions>
              <LoadingButton
                loading={loadingButton}
                onClick={() => {
                  setOpenSelectGuide(false);
                }}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                onClick={handleSave}
                loading={loadingButton}
                variant="contained"
              >
                Save
              </LoadingButton>
              {/* <Button onClick={handleSave} autoFocus variant={'contained'}>
                Save
              </Button>*/}
            </DialogActions>
          </Dialog>
        </>
      )}
      {openSelectPackage && (
        <>
          <Dialog open={true} onClose={handleClosePackage}>
            <DialogTitle>{`Generate Service Reservation`}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                If you select a Service Group here, their Reservations will be
                generated
              </DialogContentText>
              <Autocomplete
                onOpen={() => fetchSelectOptions()}
                openOnFocus
                sx={{
                  py: '10px',
                  '& .MuiAutocomplete-option': {
                    alignItems: 'flex-start',
                  }
                }}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.id === value.id
                }
                onChange={(event, value, reason, details) => {
                  setSelected(value);
                }}
                getOptionLabel={(option: any) => option?.name}
                getOptionKey={(option: any) => option?.id}
                options={options}
                loading={loading}
                renderOption={(props: any, option: any) => {
                  return (
                    <Box
                      {...props}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start !important',
                      }}
                    >
                      <Typography variant="body1">
                        {option?.name}
                        {option?.default_package && ' (DEFAULT)'}
                      </Typography>
                      {option?.services && (
                        <>
                          {option.services.map((service: any) => {
                            return (
                              <Typography variant="body2" color="text.secondary">
                                {service?.service_provider?.name} - {service?.name}
                              </Typography>
                            );
                          })}
                        </>
                      )}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    autoFocus
                    focused
                    label="Service Group"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20}/>
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </DialogContent>
            <DialogActions>
              <LoadingButton
                loading={loadingButton}
                onClick={() => {
                  setOpenSelectPackage(false);
                }}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                loading={loadingButton}
                onClick={handleSavePackage}
                autoFocus
                variant={'contained'}
              >
                Save
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </>
      )}
      {currentAddNewPaneEntity?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={currentAddNewPaneEntity?.schema}
            mainSchema={enumItems.serviceProvider}
            id={currentAddNewPaneEntity?.row?.id}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              setCurrentAddNewPaneEntity({
                schema: serviceProviderEventStaff,
                row: {},
              });
            }}
            propertiesFromTable={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            row={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            onClose={(value) => {
              setCurrentAddNewPaneEntity({
                schema: serviceProviderEventStaff,
                row: {},
                key: undefined,
              });
            }}
          />
        </>
      )}
    </div>
  );
};
